import * as logger from 'loglevel';
import axiosWrapper from '../../helpers/axiosWrapper';
import { NO_DURATION_DEFINED } from '../../helpers/axiosWrapper/cache';

const validateNamesResponse = (namesRaw) => {
  const validation = { isValid: true, message: '' };
  if (!Array.isArray(namesRaw)) {
    validation.isValid = false;
    validation.message =
      'INTEGRATION__MAP_SERVICES_NAME: Name SCHEMA is invalid, please check Fares API documentation.';
  }
  return validation;
};

const transformData = (namesRawData) => {
  const names = [];
  namesRawData.forEach((item) => {
    if (item.code && item.latitude && item.longitude && item.name) {
      names.push({
        name: item.name,
        code: item.code,
        markerType: 'name',
        location: [item.latitude, item.longitude]
      });
    } else {
      console.error('INTEGRATION__MAP_SERVICES_NAME: ITEMS SKIP: MISSING PARAMS', item);
      return false;
    }
  });
  return names;
};

/**
 * Retrieve fares from the GroupRoutes Endpoint
 * @param {*} filter
 * @param {*} integrationSettings
 */
const getNames = (filter, integrationSettings, meta, pageContext) => {
  /**
   * TODO: It was necessary to pass the prePopulation because the
   * displayed labels depend on the airline as well as the language code
   */
  const { enableNameService, zoom } = filter;
  if (!enableNameService) {
    return new Promise((resolve) => {
      resolve([]);
    });
  }
  return new Promise((resolve, reject) => {
    if (!integrationSettings) {
      const MESSAGE = `INTEGRATION__FARES: **integrationSettings** not especified.`;
      logger.error(MESSAGE);
      reject(MESSAGE);
    }
    const { v1MapNameServices } = integrationSettings;
    const { cache = false, cacheDuration = NO_DURATION_DEFINED } = v1MapNameServices;

    if (
      !v1MapNameServices ||
      !v1MapNameServices.method ||
      !v1MapNameServices.endPoint ||
      !v1MapNameServices.headers
    ) {
      const MESSAGE = `INTEGRATION__FARES: **integrationSettings.v1MapNameServices** configuration issues.`;
      logger.error(MESSAGE);
      reject(MESSAGE);
    }

    axiosWrapper(
      {
        method: v1MapNameServices.method,
        url: `${v1MapNameServices.endPoint}?zoom=${zoom}`,
        headers: { ...v1MapNameServices.headers }
      },
      {
        resource: 'INTEGRATION__MAP_SERVICES_NAME__GET__ITEMS',
        meta,
        pageContext,
        integrationSettings,
        cache,
        cacheDuration
      }
    )
      .then((response) => {
        const validation = validateNamesResponse(response.data);
        if (validation.isValid) {
          logger.info('INTEGRATION__MAP_SERVICES_NAME: Successful request', response.data);
          const data = transformData(response.data);
          resolve(data);
        } else {
          logger.error(validation.message, validation.data);
          reject(response.data);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export { getNames };
